import { useEffect, useState } from "react";
import CRM_API from "../../api/crmApi";

const FILTERS = ["all", "today", "missed", "upcoming", "done"];

export default function CrmFollowups({ onNavigate }) {
  const [followups, setFollowups] = useState([]);
  const [filter, setFilter] = useState("today");
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchFollowups(); }, [filter]);

  const fetchFollowups = async () => {
    try {
      setLoading(true);
      const res = await CRM_API.get("/dashboard/followups", {
        params: { type: filter },
      });
      setFollowups(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const markDone = async (id, e) => {
    e.stopPropagation();
    try {
      await CRM_API.put(`/followups/complete/${id}`);
      fetchFollowups();
    } catch (err) {
      console.log(err);
    }
  };

  const deleteFollowup = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this followup?")) return;
    try {
      await CRM_API.delete(`/dashboard/followup/${id}`);
      fetchFollowups();
    } catch (err) {
      console.log(err);
    }
  };

  const getStatus = (f) => {
    if (f.completed_at)
      return { label: "DONE", bg: "#dcfce7", color: "#16a34a" };
    if (new Date(f.next_followup) < new Date())
      return { label: "MISSED", bg: "#fee2e2", color: "#dc2626" };
    return { label: "UPCOMING", bg: "#dbeafe", color: "#2563eb" };
  };

  return (
    <div>
      <h4 className="fw-bold mb-4">Follow-ups</h4>

      {/* Filter tabs */}
      <div className="d-flex gap-2 mb-4 flex-wrap">
        {FILTERS.map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={
              filter === f
                ? "btn btn-primary btn-sm"
                : "btn btn-outline-secondary btn-sm"
            }
          >
            {f.toUpperCase()}
          </button>
        ))}
      </div>

      {loading && <p className="text-muted">Loading...</p>}

      {!loading && followups.length === 0 && (
        <p className="text-muted">No followups found for this filter.</p>
      )}

      <div className="d-flex flex-column gap-3">
        {followups.map((f) => {
          const status = getStatus(f);
          return (
            <div
              key={f.id}
              onClick={() => onNavigate("crm-lead-profile", f.lead_id)}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                padding: "16px 20px",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,.06)",
                transition: "box-shadow .15s ease",
              }}
            >
              {/* Top row */}
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h6 className="mb-1 fw-semibold">{f.student_name}</h6>
                  <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                    {f.interested_course || "No course specified"}
                  </p>
                </div>

                {/* Action buttons */}
                <div
                  className="d-flex gap-2 align-items-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  {f.student_contact && (
                    <a
                      href={`tel:${f.student_contact}`}
                      className="btn btn-sm btn-success"
                      title="Call"
                    >
                      <i className="bi bi-telephone" />
                    </a>
                  )}
                  {!f.completed_at && (
                    <button
                      onClick={(e) => markDone(f.id, e)}
                      className="btn btn-sm btn-outline-success"
                      title="Mark as done"
                    >
                      <i className="bi bi-check-lg" />
                    </button>
                  )}
                  <button
                    onClick={(e) => deleteFollowup(f.id, e)}
                    className="btn btn-sm btn-outline-danger"
                    title="Delete"
                  >
                    <i className="bi bi-trash" />
                  </button>
                </div>
              </div>

              {/* Date + remark + status */}
              <div className="d-flex justify-content-between align-items-end mt-3">
                <div>
                  <p className="mb-1" style={{ fontSize: "13px", color: "#6b7280" }}>
                    <i className="bi bi-calendar3 me-1" />
                    {f.next_followup || "No date set"}
                  </p>
                  <p
                    className="mb-0 fst-italic"
                    style={{ fontSize: "13px", color: "#374151" }}
                  >
                    {f.remark || "No remark"}
                  </p>
                </div>
                <span
                  style={{
                    padding: "4px 12px",
                    borderRadius: "999px",
                    fontSize: "11px",
                    fontWeight: 700,
                    background: status.bg,
                    color: status.color,
                    whiteSpace: "nowrap",
                  }}
                >
                  {status.label}
                </span>
              </div>

              <p className="mb-0 mt-2" style={{ fontSize: "11px", color: "#9ca3af" }}>
                Updated by {f.updated_by || "Unknown"}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
